var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-stack h-stretch gap-3"},[(!_vm.id || _vm.id == _vm.$store.state.id || _vm.$store.state.accessLevel > 9)?_c('button',{staticClass:"add",on:{"click":function($event){_vm.$router.push('/finance/loans/add/' + (_vm.id ? _vm.id : ''))}}},[_vm._v(" Take a Loan ")]):_vm._e(),_c('div',{staticClass:"h-stack v-stretch h-space-between gap-3"},[_c('a',{staticClass:"heading-title-2"},[_vm._v("Loans")]),_c('div',{staticClass:"h-stack gap-3"},[_c('label',{staticStyle:{"align-self":"center"}},[_vm._v("Created:")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.created),expression:"created"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.created)?_vm._i(_vm.created,null)>-1:(_vm.created)},on:{"change":function($event){var $$a=_vm.created,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.created=$$a.concat([$$v]))}else{$$i>-1&&(_vm.created=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.created=$$c}}}}),_c('label',{staticStyle:{"align-self":"center"}},[_vm._v("Signed:")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signed),expression:"signed"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.signed)?_vm._i(_vm.signed,null)>-1:(_vm.signed)},on:{"change":function($event){var $$a=_vm.signed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.signed=$$a.concat([$$v]))}else{$$i>-1&&(_vm.signed=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.signed=$$c}}}}),_c('label',{staticStyle:{"align-self":"center"}},[_vm._v("Canceled:")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.canceled),expression:"canceled"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.canceled)?_vm._i(_vm.canceled,null)>-1:(_vm.canceled)},on:{"change":function($event){var $$a=_vm.canceled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.canceled=$$a.concat([$$v]))}else{$$i>-1&&(_vm.canceled=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.canceled=$$c}}}})])]),_c('Table',{attrs:{"items":_vm.filteredLoans,"defaultColumn":0,"css":"80px 100px 100px 100px 100px 1fr 60px","columns":[
      {
        name: 'Date',
        sort: 'Date',
        path: ['startDate'],
        formatType: 'date',
        format: 'DD.MM.YYYY',
      },
      {
        name: 'Amount',
        sort: 'Numeric',
        path: ['amount'],
        format: 'czk',
        formatType: 'currency',
      },
      {
        name: 'Paid',
        sort: 'Numeric',
        path: ['paid'],
        format: 'czk',
        formatType: 'currency',
      },
      {
        name: 'Left To Pay',
        sort: 'Numeric',
        path: ['leftToPay'],
        format: 'czk',
        formatType: 'currency',
        styleFunction: (item) => {
          if (item.state == 'signed') {
            if (item.leftToPay > 0) {
              return 'color: red;';
            } else {
              return 'color: green;';
            }
          }
          return '';
        },
      },
      {
        name: 'Monthly',
        sort: 'Numeric',
        path: ['monthlyRate'],
        format: 'czk',
        formatType: 'currency',
      },
      {
        name: 'Description',
        sort: 'Alphabet',
        path: ['description'],
      },
      {
        name: 'State',
        sort: 'Alphabet',
        path: ['state'],
      },
    ]},on:{"rowSelected":function($event){return _vm.$router.push('/loans/detail/' + $event._id)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }